/* eslint-disable implicit-arrow-linebreak */
/**
 * Wheel of Fortune Bonus round "Letters Revealed" text input parser/formatter.
 */
angular.module('tgaAdmin').directive('wofPresetInput', () => ({
  priority: 1,
  restrict: 'A',
  require: 'ngModel',
  link(scope, element, attr, modelCtrl) {
    modelCtrl.$parsers.push((inputValue) =>
      // Parse input text into an ordered array of unique, upper-case letters in the format:
      // [{ letter: [letter] }...]
      _.uniq(_.toUpper(inputValue || '').replace(/[^A-Z]/g, '')).map((letter) => ({ letter })));

    modelCtrl.$formatters.push((modelValue) =>
      // Parse model value from array into string of concatenated upper-case letters.
      _.map(modelValue, ({ letter }) => _.toUpper(letter || null)).join(''));
  },
}));
